// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FieldTimeOutlinedSvg from "@fishx/icons-svg/es/asn/FieldTimeOutlined";
import FishxIcon from '../components/FishxIcon';

var FieldTimeOutlined = function FieldTimeOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FieldTimeOutlinedSvg
  }));
};

FieldTimeOutlined.displayName = 'FieldTimeOutlined';
export default React.forwardRef(FieldTimeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FieldTimeOutlined.js
// module id = 2677
// module chunks = 0